import { render, staticRenderFns } from "./user_jl.vue?vue&type=template&id=848bd92e&scoped=true"
import script from "./user_jl.vue?vue&type=script&lang=js"
export * from "./user_jl.vue?vue&type=script&lang=js"
import style0 from "./user_jl.vue?vue&type=style&index=0&id=848bd92e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848bd92e",
  null
  
)

export default component.exports